export const GET_ENGAGEMENTS_LIST_REQUEST = 'GET_ENGAGEMENTS_LIST_REQUEST';
export const GET_ENGAGEMENTS_LIST_SUCCESS = 'GET_ENGAGEMENTS_LIST_SUCCESS';
export const GET_ENGAGEMENTS_LIST_FAILURE = 'GET_ENGAGEMENTS_LIST_FAILURE';
